// extracted by mini-css-extract-plugin
export var active = "_2q-d";
export var blink = "_2q-e";
export var container = "_2q-5";
export var controls = "_2q-0";
export var controlsRight = "_2q-1";
export var fakeCursor = "_2q-c";
export var hidden = "_2q-b";
export var quillContainerSmall = "_2q-7";
export var quillEditor = "_2q-6";
export var quillEditorSmall = "_2q-8";
export var quillFormatButtons = "_2q-a";
export var quillToolbar = "_2q-9";
export var removePadding = "_2q-2";
export var state = "_2q-3";
export var stateTitle = "_2q-4";